import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { Checkbox } from 'redux-form-material-ui';

const MarketingEmailsField = props => (
  <Field
    name="wantsMarketingEmails"
    component={ Checkbox }
    className={ props.className }
    label= "I would like to receive iFit emails about promotions, features, and more."
  />
);

MarketingEmailsField.propTypes = {
  className: PropTypes.string,
};

export default MarketingEmailsField;